export default __webpack_public_path__ + "assets/icons/sg.6fdb95be.svg";